import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import Products from './pages/Products';
import Quotes from './pages/Quotes';
import QuoteForm from './pages/QuoteForm';
import CustomerPrices from './pages/CustomerPrices';
import HakedisForm from './pages/HakedisForm';
import Hakedisler from './pages/Hakedisler';
import HakedisTemplates from './pages/HakedisTemplates';
import Users from './pages/Users';
import Inventory from './pages/Inventory';
import Locations from './pages/Locations';
import StockMovements from './pages/StockMovements';
import Assemblies from './pages/Assemblies';
import AssemblyDetail from './pages/AssemblyDetail';
import ProductEquivalencies from './pages/ProductEquivalencies';
import SourcingProjects from './pages/SourcingProjects';
import SourcingProjectDetail from './pages/SourcingProjectDetail';
import PurchaseOrders from './pages/PurchaseOrders';
import CustomerDetail from './pages/CustomerDetail';
import Pipeline from './pages/Pipeline';
import Tasks from './pages/Tasks';
import Layout from './components/Layout';
import { getUser, hasModule } from './modules';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
}

function AdminRoute({ children }) {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  if (!token) return <Navigate to="/login" />;
  if (!user.is_admin) return <Navigate to="/" />;
  return children;
}

function ModuleRoute({ module, children }) {
  return hasModule(getUser(), module) ? children : <Navigate to="/" />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/customers" element={<ModuleRoute module="customers"><Customers /></ModuleRoute>} />
                  <Route path="/customers/:id" element={<ModuleRoute module="customers"><CustomerDetail /></ModuleRoute>} />
                  <Route path="/customers/:id/prices" element={<ModuleRoute module="customers"><CustomerPrices /></ModuleRoute>} />
                  <Route path="/crm/pipeline" element={<ModuleRoute module="crm"><Pipeline /></ModuleRoute>} />
                  <Route path="/crm/tasks" element={<ModuleRoute module="crm"><Tasks /></ModuleRoute>} />
                  <Route path="/products" element={<ModuleRoute module="products"><Products /></ModuleRoute>} />
                  <Route path="/quotes" element={<ModuleRoute module="quotes"><Quotes /></ModuleRoute>} />
                  <Route path="/quotes/:id" element={<ModuleRoute module="quotes"><QuoteForm /></ModuleRoute>} />
                  <Route path="/hakedis/:quoteId" element={<ModuleRoute module="hakedis"><HakedisForm /></ModuleRoute>} />
                  <Route path="/hakedisler" element={<ModuleRoute module="hakedis"><Hakedisler /></ModuleRoute>} />
                  <Route path="/hakedisler/yeni" element={<ModuleRoute module="hakedis"><HakedisForm /></ModuleRoute>} />
                  <Route path="/hakedisler/sablonlar" element={<ModuleRoute module="hakedis"><HakedisTemplates /></ModuleRoute>} />
                  <Route path="/hakedisler/:hakedisId" element={<ModuleRoute module="hakedis"><HakedisForm /></ModuleRoute>} />
                  <Route path="/inventory" element={<ModuleRoute module="inventory"><Inventory /></ModuleRoute>} />
                  <Route path="/locations" element={<ModuleRoute module="inventory"><Locations /></ModuleRoute>} />
                  <Route path="/stock-movements" element={<ModuleRoute module="inventory"><StockMovements /></ModuleRoute>} />
                  <Route path="/assemblies" element={<ModuleRoute module="bom"><Assemblies /></ModuleRoute>} />
                  <Route path="/assemblies/:id" element={<ModuleRoute module="bom"><AssemblyDetail /></ModuleRoute>} />
                  <Route path="/product-equivalencies" element={<ModuleRoute module="bom"><ProductEquivalencies /></ModuleRoute>} />
                  <Route path="/sourcing" element={<ModuleRoute module="sourcing"><SourcingProjects /></ModuleRoute>} />
                  <Route path="/sourcing/:id" element={<ModuleRoute module="sourcing"><SourcingProjectDetail /></ModuleRoute>} />
                  <Route path="/purchase-orders" element={<ModuleRoute module="purchase_orders"><PurchaseOrders /></ModuleRoute>} />
                  <Route path="/users" element={<AdminRoute><Users /></AdminRoute>} />
                </Routes>
              </Layout>
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
